import { render, staticRenderFns } from "./404.vue?vue&type=template&id=70bc2d14&scoped=true&"
import script from "./404.vue?vue&type=script&setup=true&lang=ts&"
export * from "./404.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./404.vue?vue&type=style&index=0&id=70bc2d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc2d14",
  null
  
)

export default component.exports